<template>
  <div v-if="!menu.hidden">
    
    <el-menu-item 
      v-if="!menu.children || menu.children.length === 0" 
      :index="resolvePath(basePath, menu.path)"
    >
      <i :class="getIcon(menu.meta)"></i>
      <span slot="title">{{ menu.meta ? menu.meta.title : '' }}</span>
    </el-menu-item>

    <el-submenu v-else :index="resolvePath(basePath, menu.path)">
      <template slot="title">
        <i :class="getIcon(menu.meta)"></i>
        <span>{{ menu.meta ? menu.meta.title : '' }}</span>
      </template>
      
      <menu-item
        v-for="subMenu in menu.children"
        :key="subMenu.path"
        :menu="subMenu"
        :base-path="resolvePath(basePath, menu.path)"
      ></menu-item>
    </el-submenu>
    
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    menu: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * 拼接父级路径与子级路径，生成规范的跳转 URL
     */
    resolvePath(basePath, routePath) {
      if (!routePath) return basePath
      // 如果子路径本身就是以 / 开头的绝对路径，直接返回
      if (routePath.startsWith('/')) return routePath
      // 拼接并过滤多余的斜杠
      const fullPath = basePath ? `${basePath}/${routePath}` : routePath
      return fullPath.startsWith('/') ? fullPath : `/${fullPath}`
    },
    /**
     * 兼容接口中返回的 "#" 或者不存在的图标
     */
    getIcon(meta) {
      if (!meta || !meta.icon || meta.icon === '#') {
        return 'el-icon-menu' // 默认兜底图标
      }
      // 如果后端支持 Element 自带图标名（如 el-icon-user），直接返回；否则按你项目封装的图标规则处理
      return meta.icon.startsWith('el-icon') ? meta.icon : `el-icon-${meta.icon}`
    }
  }
}
</script>